import { type OrganizationList, isChurch } from 'models';
import { useCallback } from 'react';
import { BankLineIcon, ChurchLineIcon } from 'ui';

export const useGetOrganizationIcon = () =>
  useCallback(
    ({ organization }: { organization: OrganizationList }) =>
      isChurch({ organization }) ? <ChurchLineIcon /> : <BankLineIcon />,
    [],
  );
